import {
  baseDataCityListRegionHeaderItem, baseDataCityRegionInnerCityItem,
  baseDataLogisticsProductsDetails, baseDataPriceDetailItem, baseDataPriceDetailPriceItem,
  baseDataProductQuotation, baseDataRegionHeaderItem
} from "./productQuotation";
import {mapFromArrayToObject} from "../../../assets/js/utils";
import wangEditor from 'wangeditor'
import {isArray, isObject} from "my-tools-kit";
import {checkGetStartCityWarehouseList} from "@/components/QuotationManagement/components-productQuotation/freightPrice";
import { getDeliveryTypeByTransportType } from '../../../assets/js/baseDataRuquest'
export let allTransportTypesArray = [
  {"value":"LY","name":"陆运"},
  {"value":"HY","name":"海运"},
  {"value":"KY","name":"空运"}
];
export let integerStyleArray = [
  {label:'不取整',value:-1},
  {label:'个位取整',value:1},
  {label:'0.1取整',value:2},
  {label:'0.5取整',value:3},
  {label:'0.01取整',value:4},
];
export let distributeBubbleArray = [
  // {label:'实重',value:1},
  {label:'实重和体积重取大',value:2},
  {label:'分50%泡',value:3},
  {label:'分1/3泡',value:4},
  {label:'分30%泡',value:5},
  {label:'分70%泡',value:7},
  // {label:'体积（CBM）',value:6},
];
/* 重量转换比率 */
export let weightVolumeRatioArray = [
  {label:'167',value:167},
  {label:'200',value:200},
  {label:'230',value:230},
  {label:'300',value:300},
  {label:'350',value:350},
  {label:'363',value:363},
  {label:'400',value:400},
  {label:'500',value:500},
  {label:'600',value:600},
  {label:'700',value:700},
];
export const volumeToWeightRatioArray = [
  {label:'5000',value:5000},
  {label:'6000',value:6000},
  {label:'7000',value:7000},
  {label:'8000',value:8000}
]
export let mixinsBaseInfo = {
  data() {
    return {
      /* 有效时间 */
      validTimeValue:[],
      /* 选择框 数据 */
      yesOrNo:[
        {name:'是',id:true},
        {name:'否',id:false},
      ],
      // 物流产品
      productList:[],
      productListMapObject:{},
      allTransportTypes:allTransportTypesArray,//运输方式
      allTransportTypesMapObject:mapFromArrayToObject(allTransportTypesArray,{label: 'name', value: 'value'}),//运输方式
      // 取整方式
      // integerStyleList:integerStyleArray,
      integerStyleListMapObject:mapFromArrayToObject(integerStyleArray),
      // 分泡方式
      distributeBubbleList:distributeBubbleArray,
      // distributeBubbleListMapObject:mapFromArrayToObject(distributeBubbleArray),
      /* 物流产品详情 */
      logisticsProductsDetails:{},// baseDataLogisticsProductsDetails()
      /* 重量转换比率 */
      weightVolumeRatioList:weightVolumeRatioArray,

      /* 编辑器 */
      editor:null,
      editorTarget:'orderInformation',
      editorTargetList:[
        {name:'下单须知',id:'orderInformation',disabled:false,},
        {name:'特殊要求',id:'specialRequirements',disabled:false,},
        {name:'温馨提示',id:'warmPrompt',disabled:false,},
        {name:'包装要求',id:'packagingRequirements',disabled:false,},
        {name:'赔付标准',id:'compensationStandards',disabled:false,},
      ],
      /* 货物类型列表 */
      goodsTypeList:[],
      // 船公司列表
      transportCompanyList: [],
      transportCompanyListCopy: [],
      // 海派尾端派送方式
      HPEndDeliveryList: [],
      // 空派二级派送方式
      FPEndDeliveryList: [],
      KHEndDeliveryList: [], // 卡航
      TLEndDeliveryList: [], // 陆运
    }
  },
  created(){

  },
  methods:{
    /**
     * 切换查询时间
     */
    changeValidTimeValue(value){
      if(!value) value = [];
      this.editFormData.effectiveStartTime = value[0];
      this.editFormData.effectiveEndTime = value[1];
    },
    /**
     * 选择 物流产品
     */
    selectChangeLogisticsProduct(value){
      console.log('value', value)
      /* 物流产品详情 */
      this.logisticsProductsDetails = {};
      this.overseasWarehouseList = [];
      /* 分区设置 */
      this.regionQuotationTypeCurrent = "head";
      this.regionHeaderList = [];
      this.deliveryRegionHeaderList = [];
      this.currency = "";
      this.currencyDelivery = "";
      this.subareaList = [];
      this.cgCityList = [];
      this.subareaListCity = [];
      this.subareaListMapObject = [];

      this.cityRegionHeaderList = [];
      this.cityRegionHeaderCurrent = "";
      this.cityRegionHeaderPriceTable = [];
      this.deliveryCityRegionHeaderPriceTable = [];

      let $usePlatformQuotation = this.$refs.usePlatformQuotation;
      if($usePlatformQuotation && typeof $usePlatformQuotation.resetData === "function") $usePlatformQuotation.resetData();

      if(!value){
        return false;
      }
      const product = this.productList.find(item => item.id === value);
      const logisticsProductId = product.logisticsProductId;
      let effectiveStartTime = this.editFormData.effectiveStartTime;
      let effectiveEndTime = this.editFormData.effectiveEndTime;

      this.getLogisticsProductsDetails(value)
        .then(res => {
          let details = res.data || {};
          details.cityList = details.cityList.map(item => Object.assign(baseDataCityRegionInnerCityItem(),item));
          this.logisticsProductsDetails = details;

          let data = Object.assign(baseDataProductQuotation(),details,{
            logisticsProductCarrierId:value,
            logisticsProductId,
            effectiveStartTime,
            effectiveEndTime,
            addedServiceList: this.disposeFormQuoteAttachPriceToAddedServiceList(details.quoteAttachPrice),
            carrierProductCode:details.carrierCode||"",//运力商物流产品代码
          })
          this.editFormData = data;
          getDeliveryTypeByTransportType(data.transportType)
            .then(res => {
              console.log('getDeliveryTypeByTransportType', res);
              this.deliveryTypeList = res.map(item => {
                return {
                  label: item.namec,
                  value: item.code
                }
              })
            })
          console.log('details',details)
          this.getShippingCompanyList(details.transportType)
          // this.setDeliveryList()

          this.setEditorContent();
          if(effectiveEndTime && effectiveEndTime){
            this.validTimeValue = [effectiveStartTime,effectiveEndTime];
          }else{
            this.validTimeValue = []
          }

          // 默认一条 全包/头程
          let defaultCityRegion = baseDataCityListRegionHeaderItem();
          this.cityRegionHeaderList = [defaultCityRegion];
          this.cityRegionHeaderCurrent = defaultCityRegion._id;

          // 默认一条派送
          if(details.isSegment){
            // 还没选择可走货物类型，不应新增默认item
            // let defaultDeliveryRegion = createRegionHeaderItem({
            //   regionType:details.regionType,//分区类型
            //   type:2,//分段类型 1：全包(头程) 2:派送
            //   // chargeType:"",//计费方式: CBM:体积 KG:重量
            //   isSupportMultiGoodsTypePrice:data.isSupportMultiGoodsTypePrice,//是否支持多产品分类报价 0>false 1>true
            //   tableHeadList:details.deliveryTableHeadList||[],//价格区间
            //   goodsTypeList:data.goodsTypeList||[],//可走货物类型
            // })
            // this.deliveryRegionHeaderList = [defaultDeliveryRegion];
          }


          // this.
          if (details.regionType === 6) {
            this.getGoodsTypeByProductId(details.logisticsProductId)
          } else {
            this.getGoodsTypeList(details.podId);
          }
          if (this.judgeNeedRefreshRegionTypeDetails(logisticsProductId,data.regionType)) {
            this.getRegionTypeDetails()
              .then(res => {
                // if(this.tableData.length<=0) this.plusSubareaItem();
              });
            if (details.isSegment) this.getRegionTypeDetails(undefined, undefined,3, true);
          }
          this.getOverseasWarehouseList(details.podId);
          this.getCgCityList(details.podId);
          this.$nextTick(()=>{
            if($usePlatformQuotation && typeof $usePlatformQuotation.clickSearch === "function") $usePlatformQuotation.clickSearch();
          })
        });
    },

    /**
     * 获取 获取物流产品基本信息
     */
    getLogisticsProductsDetails(id='') {
      if(!id) return false;
      this.loading = true;
      let url = "/carrier/productPriceNew/getCarrierProductByProductId/"+id;
      return this.axios.get(url)
        .then(res=>{
          res = isObject(res.data) ? res.data : {};
          if(res.code !== 200) return Promise.reject(new Error(res.message));
          return res;
        })
        .then(res => {
          this.loading = false;
          let data = res.data||{};
          if(isArray(data.cityList)){
            data.cityList = data.cityList.map(item=>{
              return {
                cityName:item.cityName,
                id:item.cityId,
              }
            })
          }else{
            data.cityList = [];
          }
          // data.cityList.push({
          //   cityName:"测试城市",
          //   id:"123",
          // })

          if(data.id){
            data.logisticsProductId = data.id;
            delete data.id;
          }
          if(typeof data.region_type !== "undefined" && typeof data.regionType === "undefined") {
            data.regionType = data.region_type;
            delete data.region_type;
          }
          data.productname = data.name;
          return res;
        })
        .catch((res) => {
          this.loading = false;
          console.warn(res);
          this.$message.info(res.data.message || "服务器繁忙");
        });
    },
    /* 切换 富文本目标 */
    changeEditorTarget(id = ''){
      this.editorTarget = id;
      this.setEditorContent();
    },
    /**
     * 富文本编辑器
     */
    initEditor(){
      console.log(document.getElementById('editBox'));
      const editor = new wangEditor(`#editBox`);
      // 配置全屏功能按钮是否展示
      editor.config.showFullScreen = false;
      // 配置 onchange 回调函数，将数据同步到 vue 中
      editor.config.onchange = (newHtml) => {
        let target = this.editorTarget;
        if(target) this.editFormData[target] = newHtml;
      };
      // 配置菜单栏，设置不需要的菜单
      editor.config.excludeMenus = [
        'fontName',
        'indent',
        'link',
        'emoticon',
        'image',
        'video',
        'table',
        'code',
      ];
      // 创建编辑器
      editor.create();
      this.editor = editor;
      this.setEditorContent();
    },
    setEditorContent(content = this.editFormData[this.editorTarget]){
      if(!this.editor) return false;
      this.editor.txt.html(content||'');
    },
    /**
     * 获取货物类型列表
     */
    getGoodsTypeList(countryId){
      let url = "/api/fbxData/getGoodsTypeByCountryId?countryId=" + countryId;
      this.axios.get(url)
        .then(res=>{
          res = isObject(res.data) ? res.data : {};
          if(res.code !== 200) return Promise.reject(new Error(res.message));
          return res;
        })
        .then(res => {
          let list = res.datas || [];
          list = list.filter(item=> item.goodsTypeName !== "全部");
          list.forEach(item=>item.id = item.goodsTypeId);
          this.goodsTypeList = list;
        })
        .catch(res => {
          this.goodsTypeList = [];
        })
    },
    /**
     * 通过产品id获取货物信息
     */
    getGoodsTypeByProductId(priceId) {
      let url = '/api/fbxData/getGoodsTypeByProductId?productId=' + priceId
      this.axios.get(url)
        .then(res => {
          res = isObject(res.data) ? res.data : {};
          if (res.code !== 200) return Promise.reject(new Error(res.message));
          return res;
        })
        .then(res => {
          let list = res.datas || [];
          list = list.filter(item => item.goodsTypeName !== "全部");
          list.forEach(item => item.id = item.goodsTypeId);
          this.goodsTypeList = list;
        })
        .catch(res => {
          this.goodsTypeList = [];
        })
    },
    /**
     * 改变 基础信息 的 可走货物类型列表
     */
    changeBaseGoodsTypeList(val=[]){
      let ids = val.map(item=>item.id);
      this.cityRegionHeaderList.forEach(cityRegionItem=>{
        cityRegionItem.regionHeaderList.forEach(regionItem=>{
          regionItem.priceDetailList.forEach(priceDetailItem=>{
            if (this.logisticsProductsDetails.regionType === 6) {
              priceDetailItem.goodsTypeList = []
            } else if(cityRegionItem.isSupportMultiGoodsTypePrice && this.logisticsProductsDetails.regionType !== 6){
              priceDetailItem.goodsTypeList = priceDetailItem.goodsTypeList.filter(item=>ids.includes(item.id));
            }else{
              priceDetailItem.goodsTypeList= val.map(item=>item);
            }
          });
        });
      });

    },
    /**
     * 改变 基础信息 的 收货城市
     */
    changeBaseCityList(val=[]){
      let ids = val.map(item=>item.id);
      console.log(val,ids)
      let haveChange = false;
      checkGetStartCityWarehouseList(ids,this.startCitySettingWarehouseParams,this.startCitySettingWarehouseParamsLoading);
      this.cityRegionHeaderList.forEach(cityRegionItem=>{
        let cityList = cityRegionItem.cityList.filter(item=>ids.includes(item.id));
        if(cityList.length !== cityRegionItem.cityList.length) {
          cityRegionItem.cityList = cityList;
          this.refreshSingleCityRegionSelectCityValue(cityList,cityRegionItem);
          haveChange = true;
        }
      });
      if(haveChange) {
        let type = this.logisticsProductsDetails.isSegment ? "head" : "all";
        console.log("有变化",type)
        this.refreshCityRegionHeaderPriceTable(type,this.cityRegionHeaderList);
      }
    },
    /**
     * 改变 基础信息 的 派送方式
     */
    changeDeliveryType(val){
      if(val === "ZT"){
        this.editFormData.selfDelivery = 3;
        if(this.editFormData.isSegment){
          this.regionQuotationTypeCurrent = "head";
        }
      }else{
        this.editFormData.selfDelivery = 2;
      }
      this.$set(this.editFormData, 'endDeliveryTypeIds', '')
    },
    /**
     * @description 获取运输公司
     * @param transportType {String} 运输方式
     * @returns {Boolean}
     */
    getShippingCompanyList(transportType){
      let url
      switch (transportType) {
        case 'HY':
          url = '/api/filedata/findShippingCompanyAll'
          break;
        case 'KY':
          url = '/api/filedata/findAirLineAll'
          break;
        case 'LY':
          url = '/api/filedata/findLandLineAll'
          break;
        default:
      }
      if (!url) return false
      this.axios.get(url)
        .then(res=>{
          this.transportCompanyList = res.data.datas;
          this.transportCompanyListCopy = res.data.datas
        })
        .catch(err=>{
          console.log(err);
        })
    },
    getHPEndDeliveryList() {
      this.axios.get('/api/filedata/findHPEndDeliveryType')
        .then(res => {
          this.HPEndDeliveryList = res.data.datas;
        })
    },
    getKPEndDeliveryList() {
      this.axios.get('/api/filedata/findKpSecondData')
        .then(res => {
          this.FPEndDeliveryList = res.data.datas;
        })
    },
    getKHEndDeliveryList() {
      this.axios.get('/api/filedata/findKHSecondData')
        .then(res => {
          this.KHEndDeliveryList = res.data.datas;
        })
    },
    getTLEndDeliveryList() {
      this.axios.get('/api/filedata/findTLSecondData')
        .then(res => {
          this.TLEndDeliveryList = res.data.datas;
        })
    }
  },
  computed:{
    /* 可收货城市列表 */
    cityList(){
      return this.logisticsProductsDetails.cityList||[];
    },
    // 需要初始化编辑框
    needInitEditor(){
      return this.visibleValue && this.viewTypeListValue === 'baseInfo' && this.isPrecondition && !this.editor
    },
  },
  watch:{
    /* 需要初始化编辑框 */
    needInitEditor:{
      handler(newValue){
        this.$nextTick(()=>{
          if(newValue) this.initEditor();
        });
      },
      immediate:true
    },
    // 运输方式改变清空运输公司
    "editFormData.transportType"(newValue, oldValue) {
      if (newValue !== oldValue && oldValue) {
        this.editFormData.shippingCompanyList = []
        this.getShippingCompanyList(newValue)
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/QuotationManagement/components-productQuotation/baseInfo.js